<!-- components/AdvancedModulesSection.vue -->
<template>
    <section class="advanced-modules">
      <h4>二、进阶模块功能</h4>
  
    
    
     
  
      <!-- 批量查询 -->
      <section class="module-section">
        <h4>📦 批量查询</h4>
        <ul>
          <li>分为 关键词查询、补齐猎魔查询</li>
          <li>
            收费标准：
            <ul>
              <li>普通用户：关键词1分/条，补齐猎魔2分/条</li>
              <li>会员用户：关键词0.2分/条，补齐猎魔0.4分/条</li>
            </ul>
          </li>
        </ul>
      </section>
    </section>
  </template>
  
  <script>
  export default {
    name: 'AdvancedModulesSection'
  }
  </script>
  
  <style scoped>
  .module-section {
    margin-bottom: 1.5em;
    padding: 12px;
    background: #f1f5f9;
    border-radius: 6px;
  }
  .module-section h4 {
    color: #2563eb;
    margin-bottom: 0.8em;
  }
  </style>